const PERSONAL_CABINET = {
    TABS: {
        DASHBOARD: '#home-tab',
        BONUSES: '#bonuses-tab',
        MY_PROFILE: '#profile-tab',
        GAME_HISTORY: '#game-history-tab',
        TRANSACTION_HISTORY: '#transaction-tab',
    }
};

const openPersonalCabinetTab = (tab = PERSONAL_CABINET.TABS.DASHBOARD) => {
    const tabElement = $(tab);
    if (tabElement.length) tabElement.tab('show');
}